import ApiService from '@/common/api.service'
import * as pubnub from '@/common/pubnub'
import * as userSettings from '@/store/accounts/usersSettings.helpers'

import {
  CURRENT_USER,
  IS_AUTHENTICATED,
  LOGIN,
  SET_AUTH,
  PURGE_AUTH,
  CHECK_AUTH,
  UPDATE_USER,
  GET_TOKEN,
  SET_TOKEN,
  SET_IS_INVITE,
  GET_IS_INVITE,
  REQUEST_TOKEN
} from './auth.types'

const state = {
  errors: null,
  user: {
    id: null,
    account_type: {
      id: null,
      name: null,
      description: null,
      access_level: {
        level: null,
        name: null
      },
      product_code: null,
      created_at: null,
      updated_at: null
    },
    username: null,
    email: null,
    title: null,
    first_name: null,
    last_name: null,
    full_name: null,
    position: null,
    employee_no: null,
    cellphone: null,
    national_id: null,
    timezone: {},
    country: {},
    language: {},
    logged_in: false,
    ip: null,
    created_at: null,
    updated_at: null,
    accessed_at: null,
    accessed_route: null,
    user_photo_urls: {
      photo: null,
      profile_large: null,
      profile_medium: null,
      profile_small: null
    },
    partner: {},
    agency: {},
    clients: [],
    permissions: {},
    photos: [],
    pubsub: {
      enabled: false,
      publish_key: null,
      subscribe_key: null,
      sub_channels: []
    },
    filestack: {
      url: null,
      api_key: null
    },
    google: {
      maps: {
        api_url: null,
        geocoding_url: null,
        api_key: null,
        client_id: null
      }
    },
    sse: {
      url: null,
      telemetry_url: null,
      notify_url: null
    },
    settings: {}
  },
  isAuthenticated: false,
  token: null,
  isInvite: false
}

const getters = {
  [CURRENT_USER] (state) {
    return state.user
  },
  [IS_AUTHENTICATED] (state) {
    return state.isAuthenticated
  },
  [GET_TOKEN] (state) {
    return state.token
  },
  [GET_IS_INVITE] (state) {
    return state.isInvite
  }
}

const actions = {
  [LOGIN] (context, credentials) {
    context.commit(PURGE_AUTH)
    return ApiService
      .post('auth/login', {
        username: credentials.username,
        password: credentials.password
      })
      .then((response) => {
        if (response.status === 200) {
          context.commit(SET_AUTH, response.data.data)
          context.commit(SET_TOKEN, response.headers['authorization'])
          userSettings.setAll(response.data.data.settings)
          pubnub.init(response.data.data.pubsub)
        }

        return response.data.data
      })
  },
  [CHECK_AUTH] (context) {
    /*
    if (context.state.token) {
      ApiService.setHeader()
      ApiService
        .get('user')
        .then((response) => {
          context.commit(SET_AUTH, response.data.data, response.headers['authorization'])
          return response.data.data
        })
        .catch(({response}) => {
          // context.commit(SET_ERROR, response.data.errors)
        })
    } else {
      context.commit(PURGE_AUTH)
    }
    */
  },
  [UPDATE_USER] (context, payload) {
    const {username, full_name, email, password} = payload
    const user = {
      username,
      full_name,
      email
    }
    if (password) {
      user.password = password
    }

    return ApiService
      .put('user', user)
      .then((response) => {
        context.commit(SET_AUTH, response.data.data)
        return response.data.data
      })
  },
  [REQUEST_TOKEN] () {
    // Requests a new token for the currently logged in user.
    // The new token is not sent through the authorization header
    // as to not override it.
    return ApiService
      .get('auth/token')
      .then((response) => {
        return response.data.data
      })
  }
}

const mutations = {
  [SET_AUTH] (state, user) {
    state.isAuthenticated = true
    state.user = user
    state.errors = {}
  },
  [SET_TOKEN] (state, token) {
    state.token = token
  },
  [PURGE_AUTH] (state) {
    state.isAuthenticated = false
    state.user = {}
    state.errors = {}
    state.token = null
    state.isInvite = false
  },
  [SET_IS_INVITE] (state, isInvite) {
    state.isInvite = isInvite
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth/auth.js